import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    // Listen for Turbo form submissions on this form
    this.element.addEventListener('turbo:submit-start', () => this.showOverlay())
  }

  showOverlay() {
    const loadingOverlay = this.element.querySelector('[data-insurance-scan-loading]')
    if (loadingOverlay) {
      loadingOverlay.classList.remove('hidden')
    }
  }
}
